import { gql } from '@apollo/client'

export const GENERATE_PUBLIC_TOKEN = gql`
  mutation generatePublicToken($leadSourceId: Int!, $stagePipelineId: Int!, $campusId: Int) {
    generatePublicToken(
      leadSourceId: $leadSourceId,
      stagePipelineId: $stagePipelineId,
      campusId: $campusId
    ) {
      success
      token
      errors {
        field
        message
      }
    }
  }
`
